export class Queue {
    constructor() {
        this._tail = null;
        this._head = null;
        this.length = 0;
    }
    /**
     * Enqueues an object to the end of the queue.
     */
    enqueue(value) {
        const entry = { value: value, next: null };
        if (!this._head) {
            this._head = entry;
            this._tail = this._head;
        }
        else {
            this._tail.next = entry;
            this._tail = this._tail.next;
        }
        this.length++;
    }
    /**
     * Removes and returns the object at top of the queue.
     */
    dequeue() {
        if (this.length < 1) {
            throw new Error('The queue is empty.');
        }
        const value = this._head.value;
        this._head = this._head.next;
        this.length--;
        return value;
    }
    contains(item) {
        let current = this._head;
        while (current) {
            if (current.value === item) {
                return true;
            }
            current = current.next;
        }
        return false;
    }
}
